import { render, staticRenderFns } from "./PerfilRegrasAcesso.vue?vue&type=template&id=525ce21a&"
import script from "./PerfilRegrasAcesso.vue?vue&type=script&lang=js&"
export * from "./PerfilRegrasAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports